module.exports = __webpack_public_path__ + "static/img/address.f9089ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/address.png
// module id = Li64
// module chunks = 1